<script lang="ts">
  import { page } from '$app/stores';

  import { Routes } from '@shared/configs';
  import { Breadcrumbs } from '@shared/ui/breadcrumbs';
</script>

{#if $page.route.id !== Routes.ArtistWalletAuthorization}
  <Breadcrumbs classes="mx-auto px-5 md:px-8 lg:py-3 xl:px-12" />
{/if}

<slot />
